import { Link } from "react-router-dom";
function NavItems({ prop, darkMode }) {
  const { item, route, icon } = prop;
  return (
    <>
      <div className="nav__btn">
        <Link to={route} className="nav__link">
          {item}
        </Link>
        <Link to={route} className={"nav__icon"}>
          <i className={darkMode === "dark" ? "icon" : "icon__dark"}>{icon}</i>
        </Link>
      </div>
    </>
  );
}

export default NavItems;
